function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" {...props}><path d="M15.77 16.412a.455.455 0 0 1 .642-.643l4.546 4.546a.455.455 0 1 1-.643.643l-4.546-4.546zm-5.523 2.082a8.247 8.247 0 1 1 0-16.494 8.247 8.247 0 0 1 0 16.494zm0-.91a7.338 7.338 0 1 0 0-14.675 7.338 7.338 0 0 0 0 14.675z" /></svg>;
});